import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export function formatNumber(value: number, digits = 0): string {
  if (Number.isNaN(value) || value === null || value === undefined) return '-';
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  }).format(value);
}

export function formatCompactNumber(value: number): string {
  if (Number.isNaN(value)) return '-';
  return new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(
    value,
  );
}

export function formatCurrency(value: number, currency = 'USD'): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(value);
}

export function formatPercent(value: number, digits = 1): string {
  return `${(value * 100).toFixed(digits)}%`;
}

export function formatDate(value: string | number | Date, fmt = 'YYYY-MM-DD'): string {
  return dayjs(value).format(fmt);
}

export function formatDateTime(value: string | number | Date): string {
  return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
}

export function fromNow(value: string | number | Date): string {
  return dayjs(value).fromNow();
}
